import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import forms from "../../../../Data/Forms/Settings/Branches/forms";
import headers from "../../../../Data/Forms/Settings/Branches/headers";
import {
  create_branch,
  get_branch,
  update_branch,
} from "../../../../Controllers/Settings/Branches";
import toast from "react-hot-toast";
import { convert_to_file } from "../../../../Controllers/Global";
import Loadercomponent from "../../../../Componets/Loader";

const BranchesForm = ({ isModal = false, onClose }) => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const hasFiscalYearOverlap = (fiscalYears = []) => {
    if (!Array.isArray(fiscalYears) || fiscalYears.length <= 1) return false;

    const periods = fiscalYears
      .filter((item) => item.start && item.end)
      .map((item) => ({
        start: new Date(item.start),
        end: new Date(item.end),
      }));

    for (let i = 0; i < periods.length; i++) {
      if (periods[i].start > periods[i].end) {
        return "Fiscal year start date cannot be after end date.";
      }

      for (let j = i + 1; j < periods.length; j++) {
        if (
          periods[i].start <= periods[j].end &&
          periods[j].start <= periods[i].end
        ) {
          return "Fiscal year date ranges cannot overlap.";
        }
      }
    }

    return false;
  };

  const formdata = async (data) => {
    if (data?.status) {
      const overlapError = hasFiscalYearOverlap(data?.data?.fiscal_years || []);

      if (overlapError) {
        toast.error(overlapError);
        return;
      }
      
      setButtonLoader(true);

      const branch = id
        ? await update_branch({ ...data?.data, id: id })
        : await create_branch(data?.data);

      if (branch?.status) {
        if (isModal) {
          onClose && onClose();
        } else {
          navigate(-1);
        }
        toast?.success(branch?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (branch?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(branch?.message);
        }
      }
    }
  };

  const handleData = async (branch) => {
    let image = branch?.image ? branch?.image : "";
    let file = await convert_to_file(image);
    let name = branch?.name ? branch?.name : "";
    let email = branch?.email ? branch?.email : "";
    let phone = branch?.phone ? branch?.phone : "";
    let tax = branch?.tax ? branch?.tax : "";
    let area = branch?.area ? branch?.area : "";
    let city = branch?.city ? branch?.city : "";
    let state = branch?.state ? branch?.state : "";
    let country = branch?.country ? branch?.country : "";
    let status = branch?.status ? branch?.status : 0;
    let billing = branch?.billing ? branch?.billing : 0;
    let bank_name = branch?.bank_name ? branch?.bank_name : "";
    let bank_branch = branch?.bank_branch ? branch?.bank_branch : "";
    let bank_account_name = branch?.bank_account_name
      ? branch?.bank_account_name
      : "";
    let bank_account_number = branch?.bank_account_number
      ? branch?.bank_account_number
      : "";
    let bank_swift = branch?.bank_swift ? branch?.bank_swift : "";
    let fiscal_years = branch?.fiscal_years || [];

    values[0].options[0].form.value = file;
    values[0].options[1].form.value = name;
    values[0].options[2].form.value = email;
    values[0].options[3].form.value = phone;

    values[1].options[0].form.value = tax;

    values[2].options[0].form.value = area;
    values[2].options[1].form.value = city;
    values[2].options[2].form.value = state;
    values[2].options[3].form.value = country;

    values[3].options[0].form.value = status;

    values[4].options[0].form.value = billing;

    values[5].options[0].form.value = bank_name;
    values[5].options[1].form.value = bank_branch;
    values[5].options[2].form.value = bank_account_name;
    values[5].options[3].form.value = bank_account_number;
    values[5].options[4].form.value = bank_swift;

    const fiscalYearIndex = values.findIndex(
      (section) => section.name === "Fiscal Year Details",
    );
    if (fiscalYearIndex !== -1) {
      const fiscalYearOption = values[fiscalYearIndex].options.find(
        (opt) => opt.form.name === "fiscal_years",
      );
      if (fiscalYearOption) {
        fiscalYearOption.form.value = fiscal_years;
      }
    }

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const branch = await get_branch(data);
      if (branch?.status) {
        handleData(branch?.data);
      } else {
        toast?.error(branch?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const content = (
    <Loadercomponent loader={loader}>
      <Forms
        form={values}
        setForm={setValues}
        formdata={formdata}
        buttonLoader={buttonLoader}
        isModal={isModal}
        onModalClose={onClose}
      />
    </Loadercomponent>
  );

  return isModal ? (
    content
  ) : (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      {content}
    </Header>
  );
};

export default BranchesForm;
